import { createIcon } from './IconPrimitive';

export const VerticalOutputIcon = createIcon(
  'VerticalOutputIcon',
  <path d="M16.023 2H8.386A2.387 2.387 0 0 0 6 4.386v16.228A2.387 2.387 0 0 0 8.386 23h7.637a2.387 2.387 0 0 0 2.386-2.386V4.386A2.387 2.387 0 0 0 16.023 2m-3.818 20.046a1.43 1.43 0 0 1-1.432-1.432c0-.793.64-1.432 1.431-1.432.793 0 1.432.64 1.432 1.432a1.43 1.43 0 0 1-1.431 1.431m4.295-3.819H7.91V4.864h8.59z" />
);
